// Escape hatch for `@-/dev.improve.haniverse.components.ui.text` — the themed
// `Text` wrapper needs the raw RN component. Everywhere else should import
// `Text` from `@-/dev.improve.haniverse.components.ui.text` so theme tokens
// and `TextClassContext` inheritance apply by default.
export { Text } from "react-native";
